import { useForm, Controller } from 'react-hook-form';
import { useState } from 'react';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BotonEnviando } from './BotonEnviando';

export default function FormWhatsapp({ getUsuarioControlFit, dataUser, infoUser, getUsuario }) {
    const texto = "Ingresá tu número de WhatsApp argentino sin +54, sin 0 y sin 15.\nEmpezá con el código de área (ej: 11).\nSolo números, sin espacios ni guiones.";

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    var [mensajeEnviado, setMensajeEnviado] = useState(false);
    var [mensajeError, setMensajeError] = useState(false);


    const {
        control,
        handleSubmit,
        register,
        formState: { errors }
    } = useForm();


    /*
    const [phone, setPhone] = useState(''); // empieza vacío


    const handleChange = (e) => {
        const raw = e.target.value.replace(/\D/g, '');
        const formatted = raw ? '+' + raw : '';
        setPhone(formatted);
    };

    const handleKeyDown = (e) => {
        const allowed = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
        const isDigit = /[0-9]/.test(e.key);

        if (!isDigit && !allowed.includes(e.key)) {
            e.preventDefault();
        }

        // Evita borrar el + si ya está presente
        if (phone.startsWith('+') && e.target.selectionStart === 0 && e.key === 'Backspace') {
            e.preventDefault();
        }
    };
    */


    const onSubmit = async (data) => {
        //alert("enviando " + infoUser["id"]);
        var idUsuario = infoUser["id"];
        //const whatsapp = data.whatsapp.replace(/\D/g, '');


        console.log(data)
        var myObjt = { data }//, phone
        await axios
            .put(process.env.REACT_APP_URL_API + "/usuario/whatsapp/" + idUsuario, myObjt)
            .then(({ data }) => {
                console.log(data)
                //alert("hello")
                setIsLoading(false);
                getUsuarioControlFit(idUsuario);
                getUsuario();
            })
            .catch(({ data }) => console.log(data));//error
    };

    return (

        <form noValidate onSubmit={handleSubmit((data) => {
            onSubmit(data);
            setIsLoading(true);

        })}>

            <div class="registro__contenedor px-3 lg:px-10 pb-10 pt-5" >
                <h1 class="registro__titulo">Registrate</h1>
                <p class="registro__subtitulo">Completá el formulario con tus datos.</p>

                <div class="registro__contenedorForm">


                    <div class="registro__contenedorForm__celda3 ">
                        <label for="last-name" class="registro__contenedorForm__celda__titulo">WhatsApp</label>
                        <div class="registro__contenedorForm__celda__titulo">
                            <Controller
                                name="whatsapp"
                                control={control}
                                defaultValue=""
                                rules={{
                                    validate: (value) =>
                                        value === '' || /^\d{10,11}$/.test(value) || 'Número inválido (mínimo 10, máximo 11 dígitos).'
                                }}
                                render={({ field }) => (
                                    <input
                                        type="tel"
                                        value={field.value}
                                        onChange={(e) => {
                                            const soloNumeros = e.target.value.replace(/\D/g, ''); // elimina letras y símbolos
                                            field.onChange(soloNumeros);
                                        }}

                                        /*
                                        onChange={(e) => {
                                            handleChange(e);
                                            const raw = e.target.value.replace(/\D/g, '');
                                            field.onChange(raw ? '+' + raw : '');
                                        }}
                                        onKeyDown={handleKeyDown}
                                        */
                                        placeholder="1173649111"
                                        className={`registro__contenedorForm__celda__contenedor__input ${errors.whatsapp ? 'formularioError' : 'formulario1'}`}

                                    />
                                )}
                            />
                            {errors.whatsapp && <div className='text-red-500 !leading-tight mt-1'>{errors.whatsapp.message}</div>}





                        </div>
                    </div>








                </div>
                <p className="registro__subtitulo !leading-tight mt-2  lg:whitespace-pre-line">
                    {texto}
                </p>




                <div class="registro__pie !justify-center lg:!justify-end registro__contenedor  pb-0">
                    <div className="grid grid-cols-1 lg:grid-cols-2">
                        <div className="text-center pb-2 lg:text-left lg:pb-0 content-center">

                        </div>
                        <div>
                            <button disabled={isLoading} type='submit' class="flex  justify-center rounded-md bg-[#b70100] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-[#d40000] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#ED1C24]" onClick={() => {

                            }}>
                                {isLoading ?
                                    <BotonEnviando texto="Guardando"></BotonEnviando>
                                    : 'Guardar'}
                            </button>
                        </div>
                    </div>



                </div>

            </div>




        </form >

    );
}